import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import { Typography } from '../../../typography'
import { getTextVariantColor } from '../../utils/get-text-variant-color'
import { useTagContext } from '../../utils/tag.context'

import * as styles from './tag-text.styles'

type Props = {
  children: ReactNode
  className?: string
  uppercase?: boolean
}

export const TagText = ({ children, className, uppercase = true }: Props) => {
  const theme = useTheme()
  const { size, variant } = useTagContext()

  const textColor = getTextVariantColor(variant)

  return (
    <Typography
      className={className}
      color={textColor}
      css={[styles.textSize(theme)[size], uppercase && styles.uppercase]}
      fontWeight="medium"
      variant={size === 'medium' ? 'b3' : 'b4'}
    >
      {children}
    </Typography>
  )
}
